var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 31,
    viewBox: "0 0 18 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 31H0.97168V0H17.9998V31ZM1.6806 30.2843H17.2909V0.715715H1.6806V30.2843Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4714 5.573H3.50488V2.79126H15.4714V5.573ZM4.2138 4.85729H14.7625V3.50697H4.2138V4.85729Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4714 9.87696H3.50488V7.09521H15.4714V9.87696ZM4.2138 9.16125H14.7625V7.81093H4.2138V9.16125Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4714 14.1853H3.50488V11.4036H15.4714V14.1853ZM4.2138 13.4696H14.7625V12.1193H4.2138V13.4696Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0336 26.3811H7.93799V23.2559H11.0336V26.3811ZM8.6469 25.6654H10.3247V23.9716H8.6469V25.6654Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6519 18.3604H5.32446V19.0761H13.6519V18.3604Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.e8e91ef15a349efb329571bd2c785825.svg";
export { ForwardRef as ReactComponent };